import React from 'react';
import {IProductSnippet} from 'shared/types/productSnippet.types';
import {ButtonV3} from 'components/ButtonV3';

type TSubscribeButtonProps = Pick<IProductSnippet['cart'], 'onSubscribe'> & Pick<IProductSnippet, 'url'>;

export const SubscribeButton = (props: TSubscribeButtonProps) => {
    const {onSubscribe, url} = props;

    return (
        <ButtonV3 isStretched={true} href={url} theme={'secondary'} onClick={onSubscribe} size={'small'}>
            Узнать о наличии
        </ButtonV3>
    );
};
